<section class="page-head">
  <div class="container h-100">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h1>{{lang.locationSearch}}
          <span>{{lang.locationSearch}}</span>
        </h1>
      </div>
    </div>
  </div>
  <img src="assets/images/company/contact.jpg" alt="{{lang.locationSearch}}">
</section>
<div class="sub-nav">
  <ul>
    <li>
      <a [routerLink]="[lang.locationsUrl]">{{lang.OurLocation}}</a>
    </li>
    <li>
      <a [routerLink]="[lang.LocationsSearchUrl]" class="active">{{lang.locationSearch}}</a>
    </li>
  </ul>
</div>
<section class="container ptb-90">
  <div class="validation_summary" style="color:Red;display:none;">
  </div>
  <div class="d-flex flex-wrap location-search">
    <div class="location_search_field mb-2">
      <label>{{lang.zipcode}}:&nbsp;</label>
      <input type="text" [(ngModel)]="tbZip" maxlength="200" (keyup.enter)="search()" class="form-control">
      <span style="color:Red;display:none;">&nbsp;*</span>
      <span style="color:Red;display:none;">&nbsp;*</span>
    </div>
    <div class="location_search_field mb-2">
      <label>{{lang.type}}:&nbsp;</label>
      <select [(ngModel)]="ddType" class="form-control form-select">
        <option value="MRB,SMB">{{lang.metalsRecycle}}</option>
        <option value="APB">{{lang.autoParts}}</option>
        <option selected="selected" value="All">{{lang.all}}</option>
      </select>
    </div>
    <div class="location_search_field mb-2">
      <label>{{lang.distance}}:&nbsp;</label>
      <select [(ngModel)]="ddDistance" class="form-control form-select">
        <option value="20">20 {{lang.miles}}</option>
        <option value="50">50 {{lang.miles}}</option>
        <option value="100">100 {{lang.miles}}</option>
        <option value="200">200 {{lang.miles}}</option>
        <option value="25000">{{lang.unlimited}}</option>
      </select>
    </div>
    <div class="location_search_buttons mb-2">
      <input (click)="search()" type="submit" value="{{lang.search}}" class="btn btn-secondary">
    </div>
  </div>
  <div id="showZipError">
    <div class="alert alert-danger">
      {{lang.zipError}}
    </div>
  </div>
  <div id="showNoResults">
    <div>
      {{lang.noResults}} <a [routerLink]="[lang.locationsUrl]">{{lang.locations}}</a>{{lang.page}}
    </div>
  </div>
  <div class="lsr">
    <div class="row">
      <div class="col-lg-6" *ngFor="let sr of searchResults">
        <div class="border br-15">
          <div class="lr-brand-image"><img src="/images/brandLogo{{sr?.locationbrandid}}.png"
              alt="{{sr?.locationbrandname}}"></div>
          <div class="lr-info">
            <h3><a [routerLink]="[lang.locationsUrl, sr?.locationid]">{{sr?.locationname}}</a></h3>
            <div class="lr-subtitle">{{sr?.type}}</div>
            <div>{{sr?.address1}}</div>
            <div *ngIf="sr.address2 && sr.address2.length > 2">{{sr?.address2}}</div>
            <div>{{sr?.city}}, {{sr?.state}} {{sr?.postalcode}}</div>
            <div [innerHTML]="sr?.publicphone1"></div>
            <div [innerHTML]="sr?.publicphone2"></div>
          </div>
          <div class="lr-miles">{{sr?.locationDistance}} {{lang.miles}}</div>
        </div>
      </div>
    </div>
  </div>
</section>